module.exports = __webpack_public_path__ + "img/fuwuxiangmu_jpg4_fwsxq.e15c9803.png";